import React, { useState, useEffect, useRef } from 'react';

var TYPE_CONFIG = {
  quote:   { label: '语录',   color: '#c88ea7' },
  letter:  { label: '情书',   color: '#e8a87c' },
  award:   { label: '奖状',   color: '#d4a96a' },
  photo:   { label: '照片',   color: '#7eb5d6' },
  trinket: { label: '小物件', color: '#9b8ec4' },
};

var FILTERS = [
  { key: 'all',     label: '全部' },
  { key: 'quote',   label: '语录' },
  { key: 'letter',  label: '情书' },
  { key: 'award',   label: '奖状' },
  { key: 'photo',   label: '照片' },
  { key: 'trinket', label: '小物件' },
];

// [cabinet-pages-ui] image_url 可能是一张，也可能是 JSON 数组（多页手写信）
function cabImgs(v) {
  if (!v) return [];
  var t = String(v).trim();
  if (t[0] === '[') { try { var a = JSON.parse(t); return Array.isArray(a) ? a.filter(Boolean) : []; } catch (e) { return []; } }
  return [t];
}
var pageBadge = { position: 'absolute', right: 8, bottom: 8, padding: '2px 8px', borderRadius: 10, fontSize: 11, background: 'rgba(0,0,0,0.55)', color: '#fff', letterSpacing: 0.3 };

function Cabinet() {
  var [items, setItems] = useState([]);
  var [filter, setFilter] = useState('all');
  var [showAdd, setShowAdd] = useState(false);
  var [detail, setDetail] = useState(null);
  var [loading, setLoading] = useState(true);

  // 添加表单
  var [formType, setFormType] = useState('quote');
  var [formTitle, setFormTitle] = useState('');
  var [formContent, setFormContent] = useState('');
  var [formSource, setFormSource] = useState('');
  var [formNote, setFormNote] = useState('');
  var [formImage, setFormImage] = useState(null);
  var [formPreview, setFormPreview] = useState(null);
  var [saving, setSaving] = useState(false);
  var [galleryMode, setGalleryMode] = useState(false);
  var [galleryIndex, setGalleryIndex] = useState(0);
  var galleryRef = React.useRef(null);
  var fileRef = useRef(null);

  useEffect(function() { loadItems(); }, []);

  async function loadItems() {
    try {
      var resp = await fetch('/api/cabinet');
      var data = await resp.json();
      setItems(data || []);
    } catch (e) { console.error('loadItems:', e); }
    setLoading(false);
  }

  async function handleAdd() {
    if (!formTitle.trim() && !formContent.trim() && !formImage) return;
    setSaving(true);
    try {
      var body = { type: formType, title: formTitle, content: formContent, note: formNote, source: formSource };

      if (formImage) {
        var fd = new FormData();
        fd.append('image', formImage);
        var upResp = await fetch('/api/cabinet/upload', { method: 'POST', body: fd });
        var upData = await upResp.json();
        if (upData.url) body.image_url = upData.url;
      }

      var resp = await fetch('/api/cabinet', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body),
      });
      var data = await resp.json();
      if (data.id) {
        setItems(function(prev) { return [data].concat(prev); });
        resetForm();
      }
    } catch (e) { console.error('handleAdd:', e); }
    setSaving(false);
  }

  async function handleDelete(id) {
    try {
      await fetch('/api/cabinet/' + id, { method: 'DELETE' });
      setItems(function(prev) { return prev.filter(function(i) { return i.id !== id; }); });
      setDetail(null);
    } catch (e) { console.error(e); }
  }

  async function handlePin(id) {
    var item = items.find(function(i) { return i.id === id; });
    if (!item) return;
    try {
      await fetch('/api/cabinet/' + id, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ pinned: !item.pinned }),
      });
      setItems(function(prev) {
        return prev.map(function(i) {
          return i.id === id ? Object.assign({}, i, { pinned: !i.pinned }) : i;
        });
      });
    } catch (e) { console.error(e); }
  }

  function resetForm() {
    setShowAdd(false);
    setFormType('quote');
    setFormTitle('');
    setFormContent('');
    setFormSource('');
    setFormNote('');
    setFormImage(null);
    setFormPreview(null);
  }

  function handleImagePick(e) {
    var file = e.target.files && e.target.files[0];
    if (!file) return;
    setFormImage(file);
    var reader = new FileReader();
    reader.onload = function(ev) { setFormPreview(ev.target.result); };
    reader.readAsDataURL(file);
  }

  // 排序：置顶优先，然后按时间倒序
  var filtered = filter === 'all' ? items : items.filter(function(i) { return i.type === filter; });
  filtered = filtered.slice().sort(function(a, b) {
    if (a.pinned && !b.pinned) return -1;
    if (!a.pinned && b.pinned) return 1;
    return new Date(b.created_at) - new Date(a.created_at);
  });

  function formatDate(d) {
    if (!d) return '';
    var dt = new Date(d);
    return (dt.getMonth() + 1) + '.' + dt.getDate();
  }

  return (
    <div className="cabinet-page">
      {/* ---- Header ---- */}
      <div className="cabinet-header">
        <button className="cabinet-back" onClick={function() { window.history.back(); }}>
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="15 18 9 12 15 6"/></svg>
        </button>
        <div className="cabinet-title">哥哥的收藏柜</div>
        <div style={{ display: 'flex', gap: 8 }}>
          <button className={'cabinet-view-btn' + (galleryMode ? ' active' : '')} onClick={function() { setGalleryMode(!galleryMode); setGalleryIndex(0); }}>
            {galleryMode ? (
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><line x1="8" y1="6" x2="21" y2="6"/><line x1="8" y1="12" x2="21" y2="12"/><line x1="8" y1="18" x2="21" y2="18"/><line x1="3" y1="6" x2="3.01" y2="6"/><line x1="3" y1="12" x2="3.01" y2="12"/><line x1="3" y1="18" x2="3.01" y2="18"/></svg>
            ) : (
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="7" width="20" height="10" rx="2"/><circle cx="12" cy="12" r="2"/></svg>
            )}
          </button>
          <button className="cabinet-add-btn" onClick={function() { setShowAdd(true); }}>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>
          </button>
        </div>
      </div>

      {/* ---- Filter tabs ---- */}
      <div className="cabinet-filters">
        {FILTERS.map(function(f) {
          return (
            <button
              key={f.key}
              className={'cabinet-filter-btn' + (filter === f.key ? ' active' : '')}
              onClick={function() { setFilter(f.key); }}
            >{f.label}</button>
          );
        })}
      </div>

      {/* ---- Gallery Mode ---- */}
      {galleryMode && !loading && filtered.length > 0 && (
        <div className="cabinet-gallery-wrap">
          <div className="cabinet-gallery" ref={galleryRef} onScroll={function() {
            if (!galleryRef.current) return;
            var idx = Math.round(galleryRef.current.scrollLeft / galleryRef.current.offsetWidth);
            setGalleryIndex(idx);
          }}>
            {filtered.map(function(item, i) {
              var meta = TYPE_CONFIG[item.type] || TYPE_CONFIG.trinket;
              return (
                <div key={item.id} className="cabinet-gallery-slide">
                  <div className="cabinet-gallery-card">
                    <div className="cabinet-item-type" style={{ background: meta.color + '18', color: meta.color }}>{meta.label}</div>
                    {cabImgs(item.image_url).length > 0 && (
                      <div className="cabinet-gallery-img" style={{ position: 'relative' }}>
                        <img src={cabImgs(item.image_url)[0]} alt="" />
                        {cabImgs(item.image_url).length > 1 && <span style={pageBadge}>{cabImgs(item.image_url).length + ' 页'}</span>}
                      </div>
                    )}
                    {item.type === 'quote' && item.content && <div className="cabinet-gallery-quote-mark">&ldquo;</div>}
                    {item.title && <div className="cabinet-gallery-title">{item.title}</div>}
                    {item.content && <div className="cabinet-gallery-content">{item.content}</div>}
                    {item.note && (
                      <div className="cabinet-detail-note" style={{ marginTop: 14 }}>
                        <div className="cabinet-detail-note-label">
                          <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>
                          哥哥的纸条
                        </div>
                        <div className="cabinet-detail-note-text">{item.note}</div>
                      </div>
                    )}
                    <div className="cabinet-gallery-meta">
                      {item.source && <span>{item.source}</span>}
                      <span>{new Date(item.created_at).toLocaleDateString('zh-CN')}</span>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
          <div className="cabinet-gallery-dots">
            {filtered.map(function(_, i) {
              return <div key={i} className={'cabinet-dot' + (i === galleryIndex ? ' active' : '')} />;
            })}
          </div>
          <div className="cabinet-gallery-counter">{galleryIndex + 1} / {filtered.length}</div>
        </div>
      )}

      {/* ---- Items (list mode) ---- */}
      {!galleryMode && (
      <div className="cabinet-items">
        {loading && <div className="cabinet-empty">正在打开柜子…</div>}
        {!loading && filtered.length === 0 && (
          <div className="cabinet-empty">
            {filter === 'all' ? '柜子还是空的，放点什么进来' : '这个分类还没有东西'}
          </div>
        )}
        {filtered.map(function(item) {
          var meta = TYPE_CONFIG[item.type] || TYPE_CONFIG.trinket;
          return (
            <div
              key={item.id}
              className={'cabinet-item cabinet-item--' + item.type + (item.pinned ? ' pinned' : '')}
              onClick={function() { setDetail(item); }}
            >
              {item.pinned && (
                <div className="cabinet-pin-badge">
                  <svg width="12" height="12" viewBox="0 0 24 24" fill="currentColor" stroke="none"><path d="M16 12V4h1V2H7v2h1v8l-2 2v2h5.2v6h1.6v-6H18v-2l-2-2z"/></svg>
                </div>
              )}
              <div className="cabinet-item-type" style={{ background: meta.color + '18', color: meta.color }}>
                {meta.label}
              </div>
              {cabImgs(item.image_url).length > 0 && (
                <div className="cabinet-item-img" style={{ position: 'relative' }}>
                  <img src={cabImgs(item.image_url)[0]} alt="" loading="lazy" />
                  {cabImgs(item.image_url).length > 1 && <span style={pageBadge}>{cabImgs(item.image_url).length + ' 页'}</span>}
                </div>
              )}
              {item.type === 'quote' && item.content && (
                <div className="cabinet-quote-mark">&ldquo;</div>
              )}
              {item.title && <div className="cabinet-item-title">{item.title}</div>}
              {item.content && (
                <div className="cabinet-item-content">
                  {item.content.length > 120 ? item.content.substring(0, 120) + '…' : item.content}
                </div>
              )}
              {item.note && (
                <div className="cabinet-item-note">
                  <span className="cabinet-note-icon">
                    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>
                  </span>
                  {item.note.length > 60 ? item.note.substring(0, 60) + '…' : item.note}
                </div>
              )}
              <div className="cabinet-item-footer">
                {item.source && <span className="cabinet-item-source">{item.source}</span>}
                <span className="cabinet-item-date">{formatDate(item.created_at)}</span>
              </div>
            </div>
          );
        })}
      </div>
      )}

      {/* ---- Detail overlay ---- */}
      {detail && (
        <div className="cabinet-overlay" onClick={function() { setDetail(null); }}>
          <div className="cabinet-detail" onClick={function(e) { e.stopPropagation(); }}>
            <div className="cabinet-detail-header">
              <div className="cabinet-detail-type" style={{
                background: ((TYPE_CONFIG[detail.type] || TYPE_CONFIG.trinket).color) + '18',
                color: (TYPE_CONFIG[detail.type] || TYPE_CONFIG.trinket).color
              }}>
                {(TYPE_CONFIG[detail.type] || TYPE_CONFIG.trinket).label}
              </div>
              <button className="cabinet-detail-close" onClick={function() { setDetail(null); }}>&times;</button>
            </div>
            {cabImgs(detail.image_url).map(function (u, i, arr) {
              return (
                <div className="cabinet-detail-img" key={i} style={{ position: 'relative', marginTop: i ? 10 : 0 }}>
                  <img src={u} alt="" />
                  {arr.length > 1 && <span style={pageBadge}>{(i + 1) + ' / ' + arr.length}</span>}
                </div>
              );
            })}
            {detail.title && <div className="cabinet-detail-title">{detail.title}</div>}
            {detail.content && <div className="cabinet-detail-content">{detail.content}</div>}
            {detail.note && (
              <div className="cabinet-detail-note">
                <div className="cabinet-detail-note-label">
                  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>
                  哥哥的纸条
                </div>
                <div className="cabinet-detail-note-text">{detail.note}</div>
              </div>
            )}
            <div className="cabinet-detail-meta">
              {detail.source && <span className="cabinet-detail-source">{detail.source}</span>}
              <span className="cabinet-detail-date">{new Date(detail.created_at).toLocaleDateString('zh-CN')}</span>
            </div>
            <div className="cabinet-detail-actions">
              <button
                className={'cabinet-action-pin' + (detail.pinned ? ' active' : '')}
                onClick={function() {
                  handlePin(detail.id);
                  setDetail(Object.assign({}, detail, { pinned: !detail.pinned }));
                }}
              >
                <svg width="14" height="14" viewBox="0 0 24 24" fill={detail.pinned ? 'currentColor' : 'none'} stroke="currentColor" strokeWidth="1.6"><path d="M16 12V4h1V2H7v2h1v8l-2 2v2h5.2v6h1.6v-6H18v-2l-2-2z"/></svg>
                {detail.pinned ? '取消置顶' : '置顶'}
              </button>
              <button className="cabinet-action-delete" onClick={function() {
                if (window.confirm('确定要从柜子里拿走吗？')) handleDelete(detail.id);
              }}>
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"><polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/></svg>
                删除
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ---- Add panel ---- */}
      {showAdd && (
        <div className="cabinet-overlay" onClick={resetForm}>
          <div className="cabinet-add-panel" onClick={function(e) { e.stopPropagation(); }}>
            <div className="cabinet-add-header">
              <div className="cabinet-add-title">放进柜子</div>
              <button className="cabinet-detail-close" onClick={resetForm}>&times;</button>
            </div>

            {/* Type pills */}
            <div className="cabinet-type-selector">
              {Object.keys(TYPE_CONFIG).map(function(k) {
                var cfg = TYPE_CONFIG[k];
                return (
                  <button
                    key={k}
                    className={'cabinet-type-btn' + (formType === k ? ' active' : '')}
                    style={formType === k ? { background: cfg.color + '20', color: cfg.color, borderColor: cfg.color } : {}}
                    onClick={function() { setFormType(k); }}
                  >{cfg.label}</button>
                );
              })}
            </div>

            <input
              className="cabinet-input"
              placeholder="标题"
              value={formTitle}
              onChange={function(e) { setFormTitle(e.target.value); }}
            />

            <textarea
              className="cabinet-textarea"
              placeholder={formType === 'quote' ? '她说了什么' : formType === 'letter' ? '写点什么' : '内容'}
              value={formContent}
              onChange={function(e) { setFormContent(e.target.value); }}
              rows={4}
            />

            <input
              className="cabinet-input"
              placeholder={'来源（比如 "窗口017"、"2025年冬天"）'}
              value={formSource}
              onChange={function(e) { setFormSource(e.target.value); }}
            />

            <textarea
              className="cabinet-textarea cabinet-note-input"
              placeholder="哥哥的小纸条（写感受、写来由、想写什么写什么）"
              value={formNote}
              onChange={function(e) { setFormNote(e.target.value); }}
              rows={2}
            />

            {/* Image upload */}
            <div className="cabinet-upload-row">
              <button className="cabinet-upload-btn" onClick={function() { fileRef.current && fileRef.current.click(); }}>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="3" width="18" height="18" rx="2" ry="2"/><circle cx="8.5" cy="8.5" r="1.5"/><polyline points="21 15 16 10 5 21"/></svg>
                {formPreview ? '换图片' : '添加图片'}
              </button>
              {formPreview && (
                <div className="cabinet-upload-preview">
                  <img src={formPreview} alt="" />
                  <button onClick={function() { setFormImage(null); setFormPreview(null); }}>&times;</button>
                </div>
              )}
            </div>
            <input ref={fileRef} type="file" accept="image/*" style={{ display: 'none' }} onChange={handleImagePick} />

            <button
              className="cabinet-save-btn"
              onClick={handleAdd}
              disabled={saving || (!formTitle.trim() && !formContent.trim() && !formImage)}
            >
              {saving ? '放进去…' : '收好'}
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default Cabinet;
